
import { defineComponent } from 'vue';
// import ResponsiveRow from '@/components/responsive-row';

export default defineComponent({
  components: {
    // ResponsiveRow,
  },
  setup() {
  },
});
